import { render, staticRenderFns } from "./pandaSvgaPreview.vue?vue&type=template&id=1127b2e4&scoped=true"
import script from "./pandaSvgaPreview.vue?vue&type=script&lang=ts"
export * from "./pandaSvgaPreview.vue?vue&type=script&lang=ts"
import style0 from "./pandaSvgaPreview.vue?vue&type=style&index=0&id=1127b2e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127b2e4",
  null
  
)

export default component.exports